import { Alert, Snackbar, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideSnackbar } from "../../app/slices/commonSlice";
import TopBar from "../TopBar/TopBar";

const MainLayout = (props) => {
  const dispatch = useDispatch();
  const { children } = props;
  const { snackbar } = useSelector(({ common }) => common);
  return (
    <>
      <div className="main-body">
        <TopBar />
        <div className="content-body app-padding">
          <div>{children}</div>
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={snackbar.timeout}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          dispatch(hideSnackbar());
        }}
      >
        <Alert
          onClose={() => {
            dispatch(hideSnackbar());
          }}
          severity={snackbar.type}
        >
          <Typography className="snackbar-text">{snackbar.message}</Typography>
        </Alert>
      </Snackbar>
    </>
  );
};

export default MainLayout;
